import React from "react";
import Title from "../../ui/Title";

const CommunityBased = () => {
  return (
    <div id="community-based" className="scroll-mt-24">
      <Title title="Community-based mental health care" className="mb-6" />

      <div className="space-y-4 text-softBlack leading-loose text-base font-normal">
        <p>
          Community-based mental health interventions hold great value in
          addressing the barriers to mental healthcare.
        </p>
        <p>
          According to a{" "}
          <a
            href="https://link.springer.com/article/10.1186/s12888-019-2162-z#Abs1"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue underline"
          >
            2019 position paper
          </a>
          , community-based mental health services typically “consist of a broad
          spectrum of flexible interventions tailored to needs of users, which
          will ultimately allow people to recover in their home environment with
          support from their social network.”
        </p>
        <p>
          In a 2024{" "}
          <a
            href="https://www.who.int/southeastasia/news/detail/12-03-2024-deinstitutionalize-mental-health-care--strengthen-community-based-services--who#:~:text=Besides%20being%20more%20efficient%2C%20community,mental%20health%20care%2C%20she%20said."
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue underline"
          >
            press release
          </a>
          , the WHOcalled on countries in the Southeast Asia region to
          prioritize community-based care, and transition away from long-stay
          institutional mental health services.
        </p>
        <p>
          The{" "}
          <a
            href="https://www.who.int/southeastasia/news/detail/12-03-2024-deinstitutionalize-mental-health-care--strengthen-community-based-services--who#:~:text=Besides%20being%20more%20efficient%2C%20community,mental%20health%20care%2C%20she%20said."
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue underline"
          >
            WHO
          </a>{" "}
          highlights that community-based mental health services can increase
          coverage, reduce the treatment gap, help identify mental health
          concerns at an early stage, and reduce the need for crisis
          intervention. Community-based services emphasize the creation of safe
          and supportive living environments within broader society, which
          benefit persons with mental health conditions, promote public
          understanding among, and reduce misconceptions and stigma. These
          services have been shown to yield better results than long-term
          institution-based care (like tertiary health settings) and help
          protect the rights of people with mental health conditions.
        </p>
      </div>
    </div>
  );
};

export default CommunityBased;
